import { render, staticRenderFns } from "./KeywordFilter.vue?vue&type=template&id=3189cc7e&scoped=true&"
import script from "./KeywordFilter.vue?vue&type=script&lang=js&"
export * from "./KeywordFilter.vue?vue&type=script&lang=js&"
import style0 from "./KeywordFilter.vue?vue&type=style&index=0&id=3189cc7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189cc7e",
  null
  
)

export default component.exports